import CardStandardRejection from '@perpay-web/fintech/components/composite/PartnerOnboardingRejectedCreditKarma/CardStandardRejection';
import CardRejectedPassedKycContainer from '@perpay-web/fintech/components/containers/CardRejectedPassedKycContainer';
import {
    CREDIT_KARMA_INVITE_TO_APPLY,
    CREDIT_KARMA_LIGHTBOX,
} from '@perpay-web/fintech/constants/partnerOnboardingCodes';
import { noop } from '@perpay-web/utils/noop';

const getStandardRejectionHandlers = (isCreditKarmaPartner, handlers) =>
    isCreditKarmaPartner
        ? {
              onMount: handlers.onMountCreditKarma,
              onClickDashboard: handlers.onClickDashboardCreditKarma,
          }
        : {
              onMount: noop,
              onClickDashboard: handlers.onClickDashboardStandard,
          };

const PartnerHostedOnboardingRejectedSwitcher = ({
    partnerCode,
    passedKyc,
    handlers,
}) => {
    const isCreditKarmaPartner =
        partnerCode === CREDIT_KARMA_LIGHTBOX ||
        partnerCode === CREDIT_KARMA_INVITE_TO_APPLY;

    if (isCreditKarmaPartner || !passedKyc) {
        return (
            <CardStandardRejection
                {...getStandardRejectionHandlers(
                    isCreditKarmaPartner,
                    handlers,
                )}
                isPho={!!partnerCode}
            />
        );
    }

    return <CardRejectedPassedKycContainer isPho={!!partnerCode} />;
};

export default PartnerHostedOnboardingRejectedSwitcher;
